import React from 'react'
import AnimateImageFive from './AnimateImageFive'
import AnimateTitleFive from './AnimatedTitleFive'

const CuttingAndStitching = () => {
    return (
        <section className='section-cutting-and-stiching section-padding'>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-5'>
                    <div className='section-img-heading'>
                    <div className='animated-image-wrapper'>
                        <AnimateImageFive/>
                    </div>
                    <div className='section-title'>
                        <AnimateTitleFive/>
                     </div>
                     </div>
                </div>
                <div className='col-md-7'>
                   <div className='section-content-wrapper'>
                     <div className='section-paragraph'>
                        <p>Precision defines this stage. Once the embroidery is complete, garments or panels are measured and inspected for shrinkage and then prepared for stitching. Our tailoring unit ensures that every pattern is cut with accuracy and every seam aligns flawlessly. The result — garments that not only fit beautifully but also complement the handcrafted artistry that defines them.</p>
                     </div>
                   </div>
                </div>
                </div>
            </div>
        </section>
    )
}

export default CuttingAndStitching